/**
 * `formatter` / `parser` para los InputNumber de PLATA.
 *
 * Estan acá y no copiados en cada pantalla porque la version ingenua
 *
 *     formatter: v => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
 *     parser:    v => v.replace(/\./g, '')
 *
 * MULTIPLICA EL MONTO cuando tiene decimales: puntea también la parte decimal y
 * después el parser fusiona todo al borrar los puntos.
 *
 *     3000000.01  ->  "3.000.000.01"  ->  300000001   (x100)
 *     10000000.5  ->  "10.000.000.5"  ->  100000005   (x10)
 *
 * Con enteros los dos pasos son simétricos y se cancelan, así que el error
 * duerme hasta que aparece un decimal — y aparece: cuando un animal no tiene
 * salto configurado, el mínimo ofertable es la mejor oferta + 0.01.
 *
 * Formato argentino: punto de miles, coma decimal.
 */

/** 3000000.01 → "3.000.000,01" */
export const formatearMonto = (valor) => {
  if (valor === '' || valor === null || valor === undefined) return '';
  const [entera, decimal] = String(valor).split('.');
  const miles = entera.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return decimal != null ? `${miles},${decimal}` : miles;
};

/** "$ 3.000.000,01" → "3000000.01" */
export const parsearMonto = (texto) => String(texto ?? '')
  .replace(/\./g, '')       // puntos de miles
  .replace(',', '.')        // coma decimal → punto
  .replace(/[^\d.]/g, '');  // prefijo $, espacios, cualquier resto
